// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatafbtc } from "../../../icons/mono/build/icon-statafbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatafbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatafbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatafbtcIcon.displayName = 'StatafbtcIcon';
}

export default StatafbtcIcon;